export default __webpack_public_path__ + "static/media/blue-to-white.7622f3ac.png";